<template>
  <div class="fixed-top menucontrol-scroll bg-white">
    <Banner />
    <CourseManaCard />
  </div>
</template>

<script>
import Banner from "./component/Banner.vue";
import CourseManaCard from "./component/CourseManaCard.vue";
export default {
  components: {
    Banner,
    CourseManaCard,
  },
};
</script>

<style></style>
